import React, { memo, useMemo, useState } from 'react';
import { history } from 'umi';
import { Segment } from 'tea-component';
import PageAccess from '@gp/components/PageAccess';
import Live from './components/Live';
import Dev from './components/Dev';
import { getLocationIsValid } from '@gp/utils/common';
import {
  SEGMENT_OPT,
  SEGMENT_LIVE,
  SEGMENT_DEV,
  SEGMENT_VALUES,
} from './constants';
import {
  SLASH_G_POP,
} from '@gp/constants/const';
import { DESCRIPTION_C } from '@gp/constants/noPermissionTips';
import './index.scss';

const getInitialSegmentValue = (filterObj?: Record<string, any>): '1' | '2' => {
  const filterSegmentValue = filterObj?.segment || '';
  return SEGMENT_VALUES.includes(filterSegmentValue) ? filterSegmentValue : SEGMENT_LIVE;
};

const Projects: React.FC<IStudioOverallProjectsProps> = () => {
  const filterObj = useMemo<Record<string, any>>(() => getLocationIsValid('/Studio/PortfolioOverview'), []);

  const [segmentValue, setSegmentValue] = useState<'1' | '2'>(() => getInitialSegmentValue(filterObj));

  return (
    // 暂时没有权限这个页签直接没有，这里不需要做判断
    <PageAccess isAccess={true} description={DESCRIPTION_C}>
      <div className="dbg-studio-overall-projects">
        <Segment
          className="dbg-studio-overall-projects-segment segment-light"
          value={segmentValue}
          options={SEGMENT_OPT}
          onChange={(value: '1' | '2') => {
            const filter = { ...filterObj, segment: value };
            const newFilter = encodeURIComponent(JSON.stringify(filter));
            history.replace(`${SLASH_G_POP}/Studio/PortfolioOverview?filter=${newFilter}`);
            setSegmentValue(value);
          }}
        />

        {/* Live */}
        {segmentValue === SEGMENT_LIVE && (
          <Live />
        )}

        {/* Development */}
        {segmentValue === SEGMENT_DEV && (
          <Dev />
        )}
      </div>
    </PageAccess>
  );
};

export default memo(Projects);
